/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { VisitIdsDtoModel, VisitIdsDtoModelType } from "./VisitIdsDtoModel"
import { VisitIdsDtoModelSelector } from "./VisitIdsDtoModel.base"
import { RootStoreType } from "./index"


/**
 * ProjectUnscheduledStopsDeletedDtoBase
 * auto generated base class for the model ProjectUnscheduledStopsDeletedDtoModel.
 *
 * Unscheduled stops bulk deletion
 */
export const ProjectUnscheduledStopsDeletedDtoModelBase = ModelBase
  .named('ProjectUnscheduledStopsDeletedDto')
  .props({
    __typename: types.optional(types.literal("ProjectUnscheduledStopsDeletedDto"), "ProjectUnscheduledStopsDeletedDto"),
    projectId: types.union(types.undefined, types.string),
    deletedVisits: types.union(types.undefined, types.array(types.late((): any => VisitIdsDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ProjectUnscheduledStopsDeletedDtoModelSelector extends QueryBuilder {
  get projectId() { return this.__attr(`projectId`) }
  deletedVisits(builder: string | VisitIdsDtoModelSelector | ((selector: VisitIdsDtoModelSelector) => VisitIdsDtoModelSelector) | undefined) { return this.__child(`deletedVisits`, VisitIdsDtoModelSelector, builder) }
}
export function selectFromProjectUnscheduledStopsDeletedDto() {
  return new ProjectUnscheduledStopsDeletedDtoModelSelector()
}

export const projectUnscheduledStopsDeletedDtoModelPrimitives = selectFromProjectUnscheduledStopsDeletedDto().projectId
